import React, { useState } from 'react';
import * as a from '../../../../_ancientLibrary/components/';
import { ID } from '../../../../../_metronic/helpers';

type Props = {
    groupName?: string;
    groupId: ID;
};

const API_URL = process.env.REACT_APP_API_URL;

export const ReportBuilderGroup: React.FC<Props> = ({ groupName, groupId, children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const openGroup = () => {
        setIsOpen(!isOpen);
    };

    return (
        <a.AncientTabBody
            name={groupName}
            tabType="Group"
            onOpen={() => openGroup()}
        >
            {isOpen ? (
                <div className="ps-5">
                    {children}
                </div>
            ) : (
                <></>
            )}
        </a.AncientTabBody>
    );
};
